

export const OperatorUserModel = {
    id: null,
    login: "", 
    password: "", 
    name: "", 
    email: false, 
    company: null, 
    phoneNumber: '', 
    jobTitle: "", 
    faxNumber: "" ,
    neverExpires: false,
    roles: [],
    agencyId:"",
    agencyName:"",
    approved:"",
    updated:""
    
  };

export const getAllOperatorUsers = async (setOperatorUsers) => {
    var endpoint = '/users/operator/all.json';
    try {
        const res = await fetch ( process.env.REACT_APP_API_HOST + endpoint, {
            method:'GET',
        });
        res.json().then((res) => {
            setOperatorUsers(res.data)
        });
    
    if (!res.ok) {
        throw new Error( `Error ${res.status} : ${res.statusText}`)
        }
    } catch(err){}
};

export const getOperatorUser = async (userId, setOperatorUser) => {
    var endpoint = '/users/operator/' + userId + '/user.json';
    try {
        const res = await fetch( process.env.REACT_APP_API_HOST + endpoint, {
            method: 'GET',
        });
        res.json().then((res) => {
            setOperatorUser(res.data)
        });
        if (!res.ok){
            throw new Error(`Error ${res.status} : ${res.statusText}`)
        }
    }catch (err) {}
};

export const createOperatorUserAcc = async (operatorUser) => {
    var endpoint = '/users/operator/create.json';
    // operatorUser.creationDate=new Date().toISOString();
    // operatorUser.lastUpdate=new Date().toISOString();
    try {
      const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(operatorUser)
      })
        .then((res) => {
          alert("New Operator User Account is Created");
        })
        .then((data) => {
        });
  
      if (!res.ok) {
        throw new Error(`Error ${res.status}: ${res.statusText}`);
      }
    } catch (err) {}
  };

export const updateOperatorUser = async(operatorUser) => {
    var endpoint ='/users/operator/'+ operatorUser.id + '/user.json';
    try {
        const res = await fetch( process.env.REACT_APP_API_HOST + endpoint, {
            method:'POST',
            headers: {
                "Content-Type": "application/json",
              },
            body: JSON.stringify(operatorUser),
        })
        .then((res) => {
            alert("Operator User Account has been Updated");
          })
          .then((data) => {
          });
    
        if(!res.ok){
            throw new Error(`Error ${res.status} : ${res.statusText}`)
        }
    } catch(err){}
};

export const deleteOperatorUser = async(operatorUser) => {
    var endpoint ='/users/operator/'+ operatorUser.id + '/user.json';
    try {
        const res = await fetch( process.env.REACT_APP_API_HOST + endpoint, {
            method:'DELETE',
        })
        .then((res) => {
            alert("Operator User Account has been Deleted");
          })
          .then((data) => {
          });
    
        if(!res.ok){
            throw new Error(`Error ${res.status} : ${res.statusText}`)
        }
    } catch(err){}
};

export const getRoles = async(id, setRoles) => {
    var endpoint = '/users/operator/roles.json';
    try{
        const res = await fetch( process.env.REACT_APP_API_HOST + endpoint, {
            method: 'GET',
        });
        res.json().then((res) => {
            setRoles(res.data)
        });
        if (!res.ok) {
            throw new Error(`Error ${res.status}: ${res.statusText}`);
          }
    } catch (err) {}
};

export const getAgencies = async(setAgencies) => {
    var endpoint = '/users/operator/agencies.json';
    try{
        const res = await fetch( process.env.REACT_APP_API_HOST + endpoint, {
            method: 'GET',
        });
        res.json().then((res) => {
            setAgencies(res.data)
        });
        if (!res.ok) {
            throw new Error(`Error ${res.status}: ${res.statusText}`);
          }
    } catch (err) {}
};